(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-cookku-customer-reviews]').forEach((section) => {
      if (section.dataset.reviewsInitialized === 'true') return;
      section.dataset.reviewsInitialized = 'true';

      const track = section.querySelector('[data-review-track]');
      const previous = section.querySelector('[data-review-previous]');
      const next = section.querySelector('[data-review-next]');
      const pagination = section.querySelector('[data-review-pagination]');
      if (!track || !previous || !next) return;
      const cards = [...track.querySelectorAll('.cookku-customer-reviews__card')];
      if (!cards.length) return;
      const mobile = window.matchMedia('(max-width: 749px)');
      // Two hidden-from-assistive-tech copies preserve the next-card peek while wrapping.
      const loopClones = cards.length > 1 ? cards.slice(0, 2).map((card) => {
        const clone = card.cloneNode(true);
        clone.classList.add('cookku-customer-reviews__card--loop-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        track.appendChild(clone);
        return clone;
      }) : [];
      const slides = [...cards, ...loopClones];

      const activeSlideIndex = () => {
        const trackLeft = track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Infinity;
        (mobile.matches ? slides : cards).forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      };
      const activeIndex = () => activeSlideIndex() % cards.length;

      const updateTrackHeight = () => {
        if (!mobile.matches) {
          track.style.removeProperty('height');
          return;
        }

        const activeCard = slides[activeSlideIndex()];
        if (!activeCard) return;

        const styles = window.getComputedStyle(track);
        const padding = (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0);
        track.style.height = `${Math.ceil(activeCard.getBoundingClientRect().height + padding)}px`;
      };

      const updatePagination = () => {
        if (!pagination) return;
        pagination.hidden = !mobile.matches || cards.length < 2;
        if (!pagination.hidden) pagination.textContent = `${activeIndex() + 1} / ${cards.length}`;
      };

      const updateControls = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const canScroll = maxScroll > 2;
        previous.hidden = !canScroll;
        next.hidden = !canScroll;
        previous.disabled = !canScroll || track.scrollLeft <= 2;
        next.disabled = !canScroll || track.scrollLeft >= maxScroll - 2;
      };

      const scrollOneCard = (direction) => {
        const card = track.querySelector('.cookku-customer-reviews__card');
        if (!card) return;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      };

      let updateFrame = null;
      const scheduleUpdate = () => {
        if (updateFrame !== null) return;
        updateFrame = window.requestAnimationFrame(() => {
          updateFrame = null;
          updateControls();
          updateTrackHeight();
          updatePagination();
        });
      };

      const wrapIfNeeded = () => {
        if (!mobile.matches || !loopClones.length) return;
        const index = activeSlideIndex();
        if (index < cards.length) return;

        const cloneStart = slides[index].offsetLeft - slides[0].offsetLeft;
        const settledAt = Math.min(cloneStart, track.scrollWidth - track.clientWidth);
        if (Math.abs(track.scrollLeft - settledAt) > 4) return;

        // The copy and original look identical, so this reset is invisible after the swipe settles.
        const matchingCard = cards[index - cards.length];
        track.scrollTo({ left: matchingCard.offsetLeft - cards[0].offsetLeft, behavior: 'auto' });
        scheduleUpdate();
      };

      let settleTimer = null;
      const scheduleWrap = () => {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(wrapIfNeeded, 140);
      };

      previous.addEventListener('click', () => scrollOneCard(-1));
      next.addEventListener('click', () => scrollOneCard(1));
      track.addEventListener('scroll', () => {
        scheduleUpdate();
        if (mobile.matches) scheduleWrap();
      }, { passive: true });
      track.addEventListener('scrollend', wrapIfNeeded);
      window.addEventListener('resize', scheduleUpdate);
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(scheduleUpdate);
        cards.forEach((card) => observer.observe(card));
      }
      if (document.fonts) document.fonts.ready.then(scheduleUpdate);
      updateControls();
      updateTrackHeight();
      updatePagination();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document));
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
